import { render, staticRenderFns } from "./account-balance.vue?vue&type=template&id=10864787&scoped=true&lang=pug&"
import script from "./account-balance.vue?vue&type=script&lang=js&"
export * from "./account-balance.vue?vue&type=script&lang=js&"
import style0 from "./account-balance.vue?vue&type=style&index=0&id=10864787&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10864787",
  null
  
)

export default component.exports